import React from 'react';
import { labelStyle, rowStyle, valueStyle } from './group-settings-styles';

type Props = {
  label: string;
  value: number;
  min: number;
  max: number;
  onChange: (v: number) => void;
  onCommit: () => void;
  unit?: string;
};

export const SliderRow: React.FC<Props> = ({ label, value, min, max, onChange, onCommit, unit = 'px' }) => (
  <div style={rowStyle}>
    <span style={labelStyle}>{label}</span>
    <input
      type='range'
      min={min}
      max={max}
      step={1}
      value={value}
      onChange={e => onChange(Number(e.target.value))}
      onPointerUp={onCommit}
      style={{ flex: 1 }}
    />
    <span style={valueStyle}>
      {Math.round(value)}
      {unit}
    </span>
  </div>
);
